<template>
  <or-layout>
    <a-form layout="inline">
      <a-form-item label="时间选择">
        <a-range-picker :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
          show-time format="YYYY/MM/DD HH:mm:ss" @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType="submit" icon="search" @click="SearchInfs"></a-button>
      </a-form-item>
    </a-form>
    <a-divider></a-divider>
    <div>
      <a-button @click="exportDatas" type="primary" icon="file-excel">导出为xlsx文件</a-button>
      <a-table class="myTable" :dataSource="numdata" :rowKey="(record, index) => index" :pagination="pageinfo"
        :loading="loading" bordered>
        <!-- <a-table-column key="index" title="序号" data-index="index"/> -->
        <a-table-column key="teacher_name" title="老师姓名" data-index="teacher_name" />
        <a-table-column key="success_number" title="按时批改数" data-index="success_number" />
        <a-table-column key="error_number" title="超时批改数" data-index="error_number" />
        <a-table-column key="number" title="总数" data-index="number" />
      </a-table>
    </div>
    <!-- <a-divider></a-divider> -->
  </or-layout>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      numdata: [],
      teacher_name: '',
      pageinfo: true,
      loading: false,
      rangeConfig: '',
      statTime: '',
      endTime: '',
      exportAddress: ''
    }
  },
  mounted() {
    this.getNiuWaNum();
  },
  methods: {
    moment,
    onChange(dates, dateStrings) {
      console.log('From1: ', dates[0], ', to: ', dates[1]);
      console.log('From2: ', dateStrings[0], ', to: ', dateStrings[1]);
      this.statTime = Date.parse(dateStrings[0]) / 1000;
      console.log('this.statTime:' + this.statTime);
      this.endTime = Date.parse(dateStrings[1]) / 1000;
      console.log('this.endTime:' + this.statTime);
    },
    getNiuWaNum() {
      this.$axios
        .post("/api/TeacherPerformance/getTeacherPerformance", {
          data: {
            org_id: '326a6ccf295111320d93993af89a97b3',
            start_time: '',
            end_time: ''
          }
        })
        .then((res) => {
          // this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.numdata = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    SearchInfs() {
      this.$axios
        .post("/api/TeacherPerformance/getTeacherPerformance", {
          data: {
            org_id: '326a6ccf295111320d93993af89a97b3',
            start_time: this.statTime,
            end_time: this.endTime,
          }
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.numdata = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    exportDatas() {
      this.$axios
        .post("/api/TeacherPerformance/getTeacherPerformance", {
          data: {
            org_id: '326a6ccf295111320d93993af89a97b3',
            start_time: this.statTime,
            end_time: this.endTime,
            export: '1'
          }
        })
        .then((res) => {
          // this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.download(res.data);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    download(url) {

      var iframe = document.createElement("iframe")

      iframe.style.display = "none";

      iframe.src = url;

      document.body.appendChild(iframe);

    },
  }
}
</script>

<style>
/* .myTable tr:nth-child(odd){
        background-color: #c3e3ff;
    } */
.myHr {
  border: 1px solid transparent;
  height: 5px;
  background-color: #dfdfdf;
}
</style>
